export default {
  'posts.page-title': 'Direct Posts',
  'posts.modal.new.title': 'New Direct',
  'posts.modal.modify.title': 'Modify Direct',
  'posts.modal.title': 'Direct title',
  'posts.modal.text': 'Direct text',
  'posts.modal.url': 'Article URL',
  'posts.modal.disclaimer': 'This action cannot be undone.',
  'posts.modal.delete.title': 'Delete Post',
  'posts.modal.delete.question': 'Do you really want to delete this post?',

  'posts.table.language': 'LANG',
  'posts.table.image': 'IMAGE',
  'posts.table.title': 'TITLE/EXCERPT',
  'posts.table.source': 'SOURCE/AUTHOR',
  'posts.table.date': 'PUBLISHED',
  'posts.table.clicks': 'TOTAL CLICKS',
  'posts.table.actions': 'ACTIONS',
  'posts.table.actions.modify': 'Modify',
  'posts.table.actions.delete': 'Delete',
};
